import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Grid} from '@material-ui/core'
import {Button, TextField, IconButton} from '@material-ui/core';

import { isNumber } from '../../../api/validators';

import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDateTimePicker} from '@material-ui/pickers';

import {MoreVert} from '@material-ui/icons';
import {HighlightOff} from '@material-ui/icons';
import { SelectUserDialog } from './SelectUserDialog';
import { getDateTimeFormat } from '../../../functions/lang';

import { formatSpeed, getSpeedIn } from '../../api/Settings';

class ShowTrackDialog_ extends React.Component{

    constructor(props){
        super(props)


        const time = new Date()

        let dateFrom = this.props.formData.dateFrom
        if(dateFrom==null){
            dateFrom = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 12, 0 )
        }

        let dateTo = this.props.formData.dateTo
        if(dateTo==null){
            dateTo = new Date(time.getFullYear(), time.getMonth(), time.getDate()+1, 12, 0 )
        }


        //const {user} = this.props; 
        //const {device} = this.props;
        console.log('ShowTrackDialog constructor')
        console.log('props')
        console.log(props)
        this.state = {
            formData: {...props.formData, dateFrom: dateFrom, dateTo: dateTo},
            errors:{
                user: false
            },
            selectUserDialog:{
                open: false,
                userID: null
            },
            changed: false,
        }

        this.handleInput =  this.handleInput.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.handleDateFromChange = this.handleDateFromChange.bind(this)
        this.handleDateToChange = this.handleDateToChange.bind(this)
    }

    handleSave(){
        if(this.validate()){
            let formData = {...this.state.formData}
            this.props.onAction({
                type: 'SHOW_TRACK_DIALOG_OK', 
                formData: formData,
            })
        }
    }

    handleClose(){
        //if(this.state.changed){
        //    if(!window.confirm(this.props.t('CloseFormConfirm'))) return; 
        //}
        this.props.onAction({type: 'SHOW_TRACK_DIALOG_CLOSE'})
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const formData = {...this.state.formData, [event.target.name]: val}
        this.setState({formData: formData, ...changed})
    }

    validate(){
        const {t} = this.props

        console.log('validate')

        let errors = this.state.errors;
        let error = false

        
        if(!this.state.formData.user){
            errors.user = t('UserMustBeSpecified')
            error = true
        }else {
            errors.user = false
        }
        /*
        if(this.state.properties.pollingEnabled && !isNumber(this.state.properties.pollingTime)){
            errors.pollingTime = t('IsNotNumber')
            error = true
        }else{
            errors.pollingTime = false
        }
        */
/*
        if(!this.state.channel.ChannelName){
            errors.ChannelName = t('NameIsEmpty')
            error = true
        }else{
            errors.ChannelName = false
        }
        
        */

        this.setState({errors: errors})

        return !error;
    }

    /*
    checkPermission(permission){
        return this.props.onAction({
            type:'CHECK_PERMISSION', 
            networkID: this.props.networkID, 
            permission: permission 
        })
    }
    */


    handleDateFromChange(date){
        let formData = {...this.state.formData}
        formData.dateFrom = date
        console.log('handleDateFromChange')
        console.log(date)

        this.setState({formData: formData})
    }

    handleDateToChange(date){
        let formData = {...this.state.formData}
        formData.dateTo = date
        console.log('handleDateToChange')
        console.log(formData)

        this.setState({formData: formData})
    }

    handleAction(action){

        switch(action.type){
            case 'SELECT_USER_DIALOG_OPEN':{
                let selectUserDialog = this.state.selectUserDialog
                selectUserDialog.open = true
                this.setState({selectUserDialog: selectUserDialog})
                break
            }

            case 'SELECT_USER_DIALOG_SELECT':{
                let selectUserDialog = this.state.selectUserDialog
                selectUserDialog.open = false
                let formData = {...this.state.formData}
                let errors = {...this.errors}
                formData.user = action.user
                formData.userID = action.userID
                formData.networkID = action.networkID
                errors.user = false
                this.setState({selectUserDialog: selectUserDialog, formData: formData, errors: errors})
                break
            }

            case 'SELECT_USER_DIALOG_CLOSE':{
                let selectUserDialog = this.state.selectUserDialog
                selectUserDialog.open = false
                this.setState({selectUserDialog: selectUserDialog})
                break
            }

            case 'CLEAR_USER':{
                let formData = this.state.formData
                formData.user = ''
                formData.userID = null
                formData.networkID = null
                this.setState({formData: formData})
                break
            }

            default: {
                alert(action.type)
            }

        }

    }

    render(){
        const {t, i18n} = this.props

        const title = t('ShowTrack')

        const margin = {margin:'16px 0 8px 0'}

        let dateFormat = getDateTimeFormat(i18n)
/*
        switch(i18n.language){
            case 'ru':
                dateFormat = "dd.MM.yyyy HH:mm"
                break

            case 'en':
            default:
                dateFormat = "MM/dd/yyyy HH:mm"
        }
*/

        /*
        const time = new Date()

        let dateFrom = this.state.formData.dateFrom
        if(dateFrom==null){
            dateFrom = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 12, 0 )
        }

        let dateTo = this.state.formData.dateTo
        if(dateTo==null){
            dateTo = new Date(time.getFullYear(), time.getMonth(), time.getDate()+1, 12, 0 )
        }
        */

        

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="properties-dialog-title">

    {this.state.selectUserDialog.open? (
        <SelectUserDialog open={this.state.selectUserDialog.open}
            networkID={this.props.networkID} 
            networks={this.props.networks}
            onAction={this.handleAction} ></SelectUserDialog>
    ) : null }
        
    <DialogTitle id="properties-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Container maxWidth="lg" style={{minWidth:300}}>

            <Box textAlign="center">
                <Grid container>
                    <Grid item xs={9} align="left">
                        <TextField
                        name="user"
                        id="user"
                        onChange={()=>{this.handleAction({type: 'SELECT_USER_DIALOG_OPEN'})}}
                        label={this.state.errors["user"]!==false? this.state.errors["user"] : t("UserName")}
                        value={this.state.formData.user}
                        style={{width:'100%'}}
                        error={this.state.errors["user"]!==false}
                    />
                    </Grid>
                    <Grid item xs={3} style={{verticalAlign:'bottom', paddingTop:18}}>
                        <IconButton
                            size="small" color="inherit" aria-label="more edit" component="span"
                            onClick={()=>{this.handleAction({type: 'SELECT_USER_DIALOG_OPEN'})}}>
                            <MoreVert />
                        </IconButton>
                        <IconButton disabled={!this.state.formData.user} 
                            size="small" color="inherit" aria-label="clear" component="span"
                            onClick={()=>{this.handleAction({type: 'CLEAR_USER'})}}>
                            <HighlightOff/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <KeyboardDateTimePicker
                        style={{marginRight: 16}}
                        margin="normal"
                        id="dateFrom"
                        name="dateFrom"
                        label={t('From')}
                        cancelLabel={t('Cancel')}
                        okLabel={t('Apply')}
                        format={dateFormat}
                        value={this.state.formData.dateFrom}
                        onChange={this.handleDateFromChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />
            </Box>

            <Box>
                <KeyboardDateTimePicker
                        style={{marginRight: 16}}
                        margin="normal"
                        id="dateTo"
                        name="dateTo"
                        label={t('To')}
                        cancelLabel={t('Cancel')}
                        okLabel={t('Apply')}
                        format={dateFormat}
                        value={this.state.formData.dateTo}
                        onChange={this.handleDateToChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />
            </Box>


            <Box textAlign="left">
                <TextField 
                    name="speedOver"
                    id="speedOver"
                    label={t("SpeedOver") + ' (' + t(getSpeedIn())+')'}
                    value={this.state.formData.speedOver}
                    style={{width:'100%'}}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center" style={{marginTop:16}}>
                <TextField
                    name="accuracy"
                    id="accuracy"
                    label={t("AccurancyUpTo")}
                    value={this.state.formData.accuracy}
                    style={{width:'100%'}}
                    onChange={this.handleInput}
                />
            </Box>

        
        </Container>
        </MuiPickersUtilsProvider>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Ok')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const ShowTrackDialog = withTranslation()(ShowTrackDialog_);